import React from "react";
import Popup from "reactjs-popup";
import BreakReasons from "../../../Popups/BreakReasons";
import SipLogin from "../../../Popups/WebRtc/SipLogin";

const Header = ({
  displayName,
  todaysDate,
  type,
  hasWebRtc,
  initials,
  statusColor,
  statusLabel,
  currentStatusKey,
  currentCampaign,
  isRefreshing,
  handleRefreshAll,
  isEnabled,
  handleToggle,
  autoAnswer,
  autoAnswerVisible,
  handleAutoAnswer,
  openDialer,
  profileOpen,
  setProfileOpen,
  closeAllPopovers,
  handleSetAvailable,
  handleSetUnavailable,
  handleSetBreak,
  handleLogout,
  breakReasonsPopup,
  sipPopup,
  campaignSwitch,
}) => {
  return (
    <>
      <Popup
        open={breakReasonsPopup.open}
        modal
        nested
        position="center center"
        contentStyle={{ width: "0px", marginTop: "-10px" }}
      >
        {() => (
          <BreakReasons
            setReasonPopUp={breakReasonsPopup.setOpen}
            onlineStatus={breakReasonsPopup.onlineStatus}
            setOnlineStatus={breakReasonsPopup.setOnlineStatus}
            breakReasons={breakReasonsPopup.reasons}
            setOnlineStatusColour={breakReasonsPopup.setOnlineStatusColour}
            setIsEnabled={breakReasonsPopup.setIsEnabled}
            unregister={breakReasonsPopup.unregister}
            setIsOnPbxCall={breakReasonsPopup.setIsOnPbxCall}
          />
        )}
      </Popup>

      <Popup
        open={sipPopup.open}
        modal
        nested
        position="center center"
        contentStyle={{ width: "460px", padding: 0, borderRadius: "14px", border: "none" }}
        overlayStyle={{ background: "rgba(0,0,0,0.5)" }}
        onClose={() => sipPopup.setOpen(false)}
      >
        {() => (
          <SipLogin
            isOpen={sipPopup.open}
            setIsOpen={sipPopup.setOpen}
            setFormConfig={sipPopup.setFormConfig}
            updateConfig={sipPopup.updateConfig}
            formConfig={sipPopup.formConfig}
            connect={sipPopup.connect}
            setIsEnabled={sipPopup.setIsEnabled}
            setSipDetails={sipPopup.setSipDetails}
            sipDetails={sipPopup.sipDetails}
          />
        )}
      </Popup>

      <Popup
        open={campaignSwitch.pickerOpen}
        modal
        nested
        position="center center"
        contentStyle={{ width: "380px", padding: 0, borderRadius: "14px", border: "none" }}
        overlayStyle={{ background: "rgba(0,0,0,0.5)" }}
        onClose={() => campaignSwitch.setPickerOpen(false)}
      >
        {() => (
          <div className="dash2 campaign-picker">
            <div className="campaign-picker-head">
              <h3>Switch Campaign</h3>
              <button
                type="button"
                className="campaign-picker-close"
                onClick={() => campaignSwitch.setPickerOpen(false)}
              >
                ×
              </button>
            </div>
            {campaignSwitch.isOnActiveCall && (
              <div className="campaign-picker-notice">
                You're on an active call — end it before switching campaigns.
              </div>
            )}
            <div className="campaign-picker-list">
              {campaignSwitch.activeCampaigns.length === 0 ? (
                <div className="empty-state">No active campaigns assigned to you.</div>
              ) : (
                campaignSwitch.activeCampaigns.map((camp) => {
                  const isCurrent = String(camp.id) === String(campaignSwitch.currentCampaignId);
                  const isSwitching = campaignSwitch.switchingCampaignId === camp.id;
                  const isDisabled = campaignSwitch.isSwitchDisabled;
                  return (
                    <div
                      key={camp.id}
                      className={`campaign-picker-item${isCurrent ? " active" : ""}${isDisabled ? " disabled" : ""}`}
                      onClick={() => {
                        if (isSwitching || isCurrent || isDisabled) return;
                        campaignSwitch.setPickerOpen(false);
                        campaignSwitch.setCampaignToConfirm(camp);
                      }}
                    >
                      <div className="campaign-picker-item-main">
                        <div className="campaign-picker-item-name">{camp.name}</div>
                        <div className="campaign-picker-item-sub">
                          {isCurrent
                            ? "This is your current campaign"
                            : `${camp.tobe_called ?? 0} leads remaining`}
                        </div>
                      </div>
                      {isCurrent ? (
                        <span className="campaign-picker-badge">Current</span>
                      ) : isSwitching ? (
                        <span className="campaign-picker-badge loading">Switching…</span>
                      ) : (
                        <span className="campaign-picker-select">Select</span>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        )}
      </Popup>

      <Popup
        open={!!campaignSwitch.campaignToConfirm}
        modal
        nested
        position="center center"
        contentStyle={{ width: "380px", padding: "28px 26px", borderRadius: "14px", border: "none" }}
        overlayStyle={{ background: "rgba(0,0,0,0.5)" }}
        onClose={() => campaignSwitch.setCampaignToConfirm(null)}
      >
        {() => (
          <div className="dash2 campaign-switch-confirm">
            <div className="campaign-switch-confirm-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="17 1 21 5 17 9" />
                <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                <polyline points="7 23 3 19 7 15" />
                <path d="M21 13v2a4 4 0 0 1-4 4H3" />
              </svg>
            </div>
            <h3>Switch active campaign?</h3>
            <p>
              You&apos;re about to switch from <strong>{currentCampaign?.name || "your current campaign"}</strong> to{" "}
              <strong>{campaignSwitch.campaignToConfirm?.name}</strong>. Your current campaign&apos;s leads queue will pause and the
              new one will start loading.
            </p>
            <div className="campaign-switch-confirm-actions">
              <button
                type="button"
                className="btn-cancel"
                onClick={() => campaignSwitch.setCampaignToConfirm(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-confirm"
                onClick={() => {
                  const campaign = campaignSwitch.campaignToConfirm;
                  campaignSwitch.setCampaignToConfirm(null);
                  campaignSwitch.handleSwitchCampaign(campaign);
                }}
              >
                Switch Campaign
              </button>
            </div>
          </div>
        )}
      </Popup>

      <header onClick={closeAllPopovers}>
        <div className="header-inner" onClick={(e) => e.stopPropagation()}>
          <div className="header-left">
            <div className="brand">
              <div>
                <h1>Hi, {displayName}</h1>
                <div className="sub">{todaysDate}</div>
              </div>
            </div>
          </div>

          <div className="header-center">
            {type === "agent" && (
              <div className="campaign-pill">
                <div className="campaign-pill-text">
                  <div className="campaign-name">
                    {currentCampaign?.name || "No Active Campaign"}
                  </div>
                  <div className="campaign-remaining-badge">
                    <strong>{currentCampaign?.tobe_called ?? "—"}</strong> Leads Remaining
                  </div>
                </div>
                <div className="campaign-pill-actions">
                  <div
                    className="campaign-pill-btn refresh"
                    title="Refresh dashboard"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRefreshAll();
                    }}
                  >
                    <svg
                      className={isRefreshing ? "spin" : ""}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="23 4 23 10 17 10" />
                      <polyline points="1 20 1 14 7 14" />
                      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
                    </svg>
                  </div>
                  <div
                    className="campaign-pill-btn swap"
                    title="Switch campaign"
                    onClick={(e) => {
                      e.stopPropagation();
                      campaignSwitch.setPickerOpen(true);
                    }}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="17 1 21 5 17 9" />
                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                      <polyline points="7 23 3 19 7 15" />
                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                    </svg>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="header-right">
            {hasWebRtc && (
            <div
              className={`toggle-pill${isEnabled ? " on" : ""}`}
              onClick={handleToggle}
            >
              <span className="knob"></span>
              <span>{isEnabled ? "SIP Enabled" : "Enable SIP"}</span>
            </div>
            )}

            {hasWebRtc && autoAnswerVisible && (
            <div
              className={`toggle-pill${autoAnswer ? " on" : ""}`}
              onClick={handleAutoAnswer}
            >
              <span className="knob"></span>
              <span>{autoAnswer ? "Auto Answer On" : "Auto Answer"}</span>
            </div>
            )}

            {hasWebRtc && (
            <div style={{ position: "relative" }}>
              <div
                className="icon-btn labeled"
                title="Dialpad"
                style={{
                  background: "linear-gradient(135deg,var(--teal),var(--green))",
                  borderColor: "transparent",
                  color: "#fff",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  openDialer();
                }}
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="6" cy="5" r="1.9" />
                  <circle cx="12" cy="5" r="1.9" />
                  <circle cx="18" cy="5" r="1.9" />
                  <circle cx="6" cy="12" r="1.9" />
                  <circle cx="12" cy="12" r="1.9" />
                  <circle cx="18" cy="12" r="1.9" />
                  <circle cx="6" cy="19" r="1.9" />
                  <circle cx="12" cy="19" r="1.9" />
                  <circle cx="18" cy="19" r="1.9" />
                </svg>
                Dial
              </div>
            </div>
            )}

            {hasWebRtc && (
            <div style={{ position: "relative" }}>
              <div
                className="icon-btn"
                title="Settings"
                onClick={(e) => {
                  e.stopPropagation();
                  sipPopup.setOpen(true);
                }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="3" />
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
              </div>
            </div>
            )}

            <div style={{ width: "1px", height: "26px", background: "var(--line)" }}></div>

            <div style={{ position: "relative" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setProfileOpen((v) => !v);
                }}
              >
                <div className="avatar" style={{ background: statusColor }}>
                  {initials}
                </div>
                <div>
                  <div className="agent-name" style={{ color: statusColor }}>
                    {displayName}
                  </div>
                  <div className="agent-status" style={{ color: statusColor }}>
                    <span className="dot" style={{ background: statusColor }}></span>
                    {statusLabel}
                  </div>
                </div>
              </div>
              <div
                className={`profile-popover${profileOpen ? " open" : ""}`}
                onClick={(e) => e.stopPropagation()}
              >
                {type === "agent" && (
                  <>
                    <div
                      className={`profile-menu-item${currentStatusKey === "available" ? " active" : ""}`}
                      onClick={handleSetAvailable}
                    >
                      <span className="status-dot green"></span>Available
                    </div>
                    <div
                      className={`profile-menu-item${currentStatusKey === "unavailable" ? " active" : ""}`}
                      onClick={handleSetUnavailable}
                    >
                      <span className="status-dot red"></span>Unavailable
                    </div>
                    <div
                      className={`profile-menu-item${currentStatusKey === "break" ? " active" : ""}`}
                      onClick={handleSetBreak}
                    >
                      <span className="status-dot orange"></span>Break
                    </div>
                    <div className="profile-menu-divider"></div>
                  </>
                )}
                <div className="profile-menu-item logout" onClick={handleLogout}>
                  Logout
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
